import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { previewQuery } from '../lib/queries';

export const Route = createFileRoute('/p/$token')({
  // Unpublished drafts. Must never be indexed, and must never leak into a
  // search result ahead of the real article once it goes live.
  head: () => ({
    meta: [
      { title: 'معاينة — تلي صافي' },
      { name: 'robots', content: 'noindex, nofollow, noarchive' },
    ],
  }),
  component: PreviewPage,
});

function PreviewPage() {
  const { token } = Route.useParams();
  const { data, isLoading, isError } = useQuery({
    ...previewQuery(token),
    enabled: typeof window !== 'undefined' && token.length > 0,
    staleTime: 0,
    refetchOnMount: 'always',
  });

  if (isError) {
    return <PreviewStatus message="تعذر تحميل المعاينة." />;
  }

  if (isLoading || !data) {
    return <PreviewStatus message="جاري تحميل المعاينة..." />;
  }

  const a = data.article;
  return (
    <article>
      <p
        style={{
          background: 'orange',
          color: 'white',
          padding: '0.25rem 0.5rem',
          fontSize: '0.75rem',
          display: 'inline-block',
          marginBottom: '1rem',
        }}
      >
        APERÇU — non publié
      </p>
      <h1>{a.title}</h1>
      {a.coverMedia && (a.coverMedia.url ?? a.coverMedia.path) && (
        <img
          src={a.coverMedia.url ?? a.coverMedia.path}
          alt={a.title}
          style={{ maxWidth: '100%' }}
        />
      )}
      <div dangerouslySetInnerHTML={{ __html: a.contentHtml ?? '' }} />
    </article>
  );
}

function PreviewStatus({ message }: { message: string }) {
  return (
    <article>
      <p>{message}</p>
    </article>
  );
}
